import { FETCH_SIZE } from "./constants";

export const getTotalPages = (
  total?: number | null,
  limit: number = FETCH_SIZE
) => {
  if (!total) {
    return 1;
  }

  return Math.ceil(total / limit);
};
